module.exports = __webpack_public_path__ + "static/media/martelo.3cc14033.svg";